import { useTranslation } from 'react-i18next';

type Props = {
  onReload: () => void;
};

export function ClientUpdateBanner({ onReload }: Props) {
  const { t } = useTranslation('panels');

  return (
    <div className="pointer-events-none absolute inset-x-0 top-0 z-[70] flex justify-center p-2 pt-[max(0.5rem,env(safe-area-inset-top))] sm:p-3">
      <div className="pointer-events-auto flex max-w-lg items-center gap-3 rounded-2xl border border-[var(--accent)]/50 bg-[var(--bg-panel)] px-3 py-2.5 shadow-2xl backdrop-blur-xl sm:px-4">
        <p className="min-w-0 text-sm leading-snug text-[var(--ink)]">
          <span className="font-semibold text-[var(--accent)]">{t('clientUpdate.title')}</span>{' '}
          {t('clientUpdate.body')}
        </p>
        <button
          type="button"
          onClick={onReload}
          className="shrink-0 rounded-xl bg-[var(--accent)] px-3 py-2 text-sm font-semibold text-[#1a1408]"
        >
          {t('clientUpdate.reload')}
        </button>
      </div>
    </div>
  );
}
